module.exports = __webpack_public_path__ + "public/img/front-v1.326e1022.png";